<template>
  <main-layout>
    <template v-if="loading">
      <div class="py-5 text-xs-center">
        <v-layout fill-height align-center justify-center ma-0 row style="min-height: 400px">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </div>
    </template>
    <template v-else>
      <v-tabs v-model="state" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab :key="'package'" :href="'#package'" ripple>
          <span style="margin-left: 5px">{{ $t('Package') }}</span>
        </v-tab>
        <v-tab :key="'yourpackage'" :href="'#yourpackage'" ripple>
          <span style="margin-left: 5px">{{ $t('your package') }}</span>
        </v-tab>
      </v-tabs>
      <div v-if="state == 'yourpackage'" class="container">
        <div class="row">
          <div class="col s12">
            <h5>{{ $t('your package') }}</h5>

            <div class="z-border-red">
              <div class="row" style="margin-bottom: 0">
                <div class="col s12 text-xs-center" style="margin-top: 15px">
                  <div>
                    <p v-if="selectedBot.pagetype == 'enterprise'">
                      {{ $t('You are using Enterprise Package') }}
                    </p>
                    <p v-else-if="$store.getters.getPackage == 'premium'">
                      {{ $t('You are using Premium Package') }}
                    </p>
                    <p v-else>
                      {{
                        $t(
                          'You are using Basic Package, upgrade to Premium Package for only 500 THB/month when youre ready.'
                        )
                      }}
                    </p>
                  </div>
                </div>
                <template v-if="selectedBot.pagetype != 'enterprise'">
                  <div
                    class="col s12 text-xs-center"
                    v-if="$store.getters.getPackage != 'premium'"
                    style="margin-bottom: 15px"
                  >
                    <div>
                      <v-btn color="primary" @click="state = 'package'" depressed>{{
                        $t('Upgrade to Premium Plan')
                      }}</v-btn>
                    </div>
                  </div>
                </template>
              </div>
              <div class="hr" style="margin-bottom: 15px"></div>
              <div style="padding: 0px 15px 15px 15px">
                <label>{{ $t('Subscription Day Remaining') }}</label>
                <h5>
                  <template v-if="$store.getters.getPackage == 'premium'">
                    <template v-if="selectedBot.expriedTime > 0">
                      <countdown :time="selectedBot.expriedTime * 1000">
                        <template slot-scope="props">
                          <template v-if="props.days">
                            {{ props.days }}
                            <span class="small">{{ $t('Days') }}</span>
                          </template>
                          <template v-else-if="props.hours > 0">
                            {{ props.hours }}
                            <span class="small">{{ $t('Hours') }}</span>
                          </template>
                          <template v-else-if="props.minutes > 0">
                            {{ props.minutes }}
                            <span class="small">{{ $t('Minutes') }}</span>
                          </template>
                          <template v-else>
                            {{ props.seconds }}
                            <span class="small">{{ $t('Seconds') }}</span>
                          </template>
                        </template>
                      </countdown>
                      <!-- {{expriedTime}}  -->
                    </template>
                  </template>
                  <template v-else>-</template>
                </h5>
                <label>{{ $t('Expired Date') }}</label>
                <h5>
                  <template v-if="$store.getters.getPackage == 'premium'">{{
                    selectedBot.expireat | DateFormat('DD/MM/YYYY')
                  }}</template>
                  <template v-else>-</template>
                </h5>
                <label>{{ $t('Package Options') }}</label>
                <h5
                  v-for="(social, index) in selectedBot.packages"
                  :key="'package_option_' + index"
                >
                  <template v-if="social == 'facebook'">
                    <em class="fab fa-facebook" style="color: #3c5a99" /> Facebook Chatbot
                  </template>
                  <template v-else-if="social == 'line'">
                    <em class="fab fa-line" style="color: #00c300" /> Line Chatbot
                  </template>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="state == 'package'">
        <div class="swap-container">
          <div :class="{ first_div: !supporter || supporter == null }" style="width: 100%">
            <v-container fluid id="selectchatbottemplate">
              <h4 class="text-xs-center">{{ $t('Select a chatbot template') }}</h4>
              <presets :showBlank="false" :showSelect="false" :showCompare="true"></presets>
            </v-container>

            <div class="hr"></div>
          </div>

          <div :class="{ second_div: !supporter || supporter == null }" style="width: 100%">
            <div id="upgrade_plan" style="padding: 25px 25px">
              <div class="row">
                <div class="col s12">
                  <h4
                    v-if="currentLang == 'la' && $store.getters.getPackage == 'premium'"
                    class="text-xs-center"
                  >
                    ທ່ານກຳລັງໃຊ້ Premium Package
                  </h4>
                  <h4 v-else class="text-xs-center">
                    {{ $t('Facebook and Line Chatbot Package') }}
                  </h4>
                  <view-package></view-package>

                  <p class="text-xs-center">
                    {{ $t('** Note: User can install Chatbot only 1 page per Premium Package') }}
                  </p>
                  <p class="text-xs-center">
                    *{{
                      $t(
                        'The company reserves the rights to upgrade certain features from basic to premium without prior notice'
                      )
                    }}
                  </p>
                  <p class="text-xs-center primary-color">
                    {{
                      $t(
                        'To customize any feature or require a quotation for Chatbot, please contact Email:'
                      )
                    }}
                    <a href="mailto:sales@zwiz.ai">sales@zwiz.ai</a>
                  </p>
                  <p class="text-xs-center">
                    {{ $t('If you want to purchase more than 1 page,') }}
                    <a
                      href="https://blog.zwiz.ai/promotion-ซื้อมากกว่า-1-page/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ $t('click here') }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="hr"></div>
          </div>
        </div>

        <div style="padding: 25px 25px">
          <div class="row">
            <div class="col s12">
              <h4 class="text-xs-center" style="margin-bottom: 25px">
                {{ $t('Premium Features') }}
              </h4>
              <div
                style="
                  border: 1px solid #eee;
                  border-radius: 10px;
                  margin-top: 15px;
                  overflow: hidden;
                "
              >
                <table class="striped">
                  <thead>
                    <tr>
                      <th class="text-xs-center" style="font-size: 1.3em; width: 0">
                        {{ $t('Features') }}
                      </th>
                      <th class="text-xs-center" style="font-size: 1.3em">{{ $t('Basic') }}</th>
                      <th class="text-xs-center" style="font-size: 1.3em">{{ $t('premium') }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(items, k) in featureRows" :key="k">
                      <td
                        v-for="(item, i) in items"
                        :key="i"
                        class="text-xs-center"
                        :style="`${['yes', 'no'].includes(item) ? '' : 'width: 350px'}`"
                      >
                        <em v-if="item == 'yes'" class="fas fa-check" style="color: #90db26" />
                        <em v-else-if="item == 'no'" class="fas fa-times" style="color: red" />
                        <div v-else>{{ $t(item) }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </main-layout>
</template>

<script>
import api from '@/api'
import ViewPackage from '@/components/view/setting/ViewPackage'
import SupportCode from './SupportCode'
import { mapGetters } from 'vuex'
import Presets from '@/components/view/getstarted/Presets'

export default {
  components: {
    ViewPackage,
    SupportCode,
    Presets
  },
  data() {
    return {
      state: 'package',
      featureRows: [
        ['Platform', 'Facebook', 'Facebook, LINE Official'],
        ['Welcome Message', 'yes', 'yes'],
        ['Extra Menu', 'yes', 'yes'],
        ['Real-time Response', 'Unlimited', 'Unlimited'],
        ['Scheduling a reply', 'yes', 'yes'],
        ['Transferring conversation to another facebook page', 'yes', 'yes'],
        ['Transferring products in shop service to another facebook page', 'no', 'yes'],
        ['Advanced Conversation', 'no', 'yes'],
        ['Conversation context', 'no', 'yes'],
        ['Status & Tag', 'no', 'yes'],
        ['Reply to a comment on posts', 'all posts', 'selected posts'],
        ['Comment to Inbox2', 'all posts', 'selected posts'],
        ['Hiding comments', 'all posts', 'selected posts'],
        ['Broadcast', 'Unlimited (Basic)', 'Unlimited (Customize)'],
        ['Scheduling a broadcast', 'no', 'yes'],
        ['Shop Service', '10 Products', 'Unlimited'],
        ['Wholesale System (shop-service)', 'no', 'yes'],
        ['In-Chat Payment', 'yes', 'yes'],
        ['Settling an invoice via chat', 'yes', 'yes'],
        ['Chat log Analytics', 'Basic', 'Customize'],
        ['Advanced CRM', 'Basic', 'Customize'],
        ['Importing previous users', 'no', 'yes'],
        ['Exporting Analytics', 'no', 'yes'],
        ['Set a timer to turn on/turn off the conversation', 'no', 'yes'],
        ['AI Training', 'no', 'yes'],
        ['Shortcut for switching chatbot mode and admin mode', 'yes', 'yes'],
        ['Shortcut # for switching to admin', 'no', 'yes'],
        ['Languages', 'TH/ENG', 'All languages'],
        ['Line Flex', 'no', 'yes'],
        ['LINE Notification', 'no', 'yes'],
        ['Support', 'Queue', 'Priority'],
        ['Creating Q&A in Reply Comment', '10 Sets Limited', 'Unlimited'],
        ['Creating Q&A in Chabot Conversation', '10 Sets Limited', '300 Sets Limited']
      ],
      supporter: null,
      loading: false,
      currentBot: null
    }
  },
  async mounted() {
    this.loading = true
    if (this.$route.query.tab) {
      this.state = this.$route.query.tab
    } else {
      this.state = 'package'
    }
    try {
      var supporter = await this.getLatestSupportUsers()
      if (supporter) this.supporter = supporter
    } catch (error) {}
    this.loading = false
    if (this.$route.hash && this.$route.hash == '#selectchatbottemplate') {
      await this.$nextTick()
      await this.wait(2000)
      this.$vuetify.goTo(this.$route.hash, {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
      })
    }
  },
  computed: {
    ...mapGetters({ currentLang: 'currentLang', selectedBot: 'selectedBot' })
  },
  methods: {
    onUpdateSupportCode: function () {
      location.reload()
    },
    getLatestSupportUsers() {
      var data = {
        pageid: this.selectedBot.pageid
      }

      return new Promise((resolve, reject) => {
        api.getLatestSupportUsers(data, function (error, response) {
          if (error) {
            reject(error)
          } else {
            resolve(response.data && response.data.length > 0 ? response.data[0] : null)
          }
        })
      })
    },
    updateRoute: function () {
      this.$router.push({
        name: 'Upgrade',
        path: '/upgrade',
        query: {
          tab: this.state
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    state: function (newVal, oldVal) {
      if (newVal != oldVal) this.updateRoute()
    }
  }
}
</script>

<style lang="scss">
.zoid-outlet {
  z-index: 0 !important;
}

.swap-container {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  /* optional */
  -webkit-box-align: start;
  -moz-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}

.swap-container .first_div {
  -webkit-box-ordinal-group: 2;
  -moz-box-ordinal-group: 2;
  -ms-flex-order: 2;
  -webkit-order: 2;
  order: 2;
}

.swap-container .second_div {
  -webkit-box-ordinal-group: 1;
  -moz-box-ordinal-group: 1;
  -ms-flex-order: 1;
  -webkit-order: 1;
  order: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/view/billing/Upgrade.vue